/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { logger } from '~/utils/sentry/client-only-logger'
import { analytics } from './segment-analytics'
import { withPrefix, getAppEventParams } from './utils'
import type { AppTrackingData } from '~/types/tracking'

const trackBookDemoButtonClick = (params: AppTrackingData) => {
  const eventParams = getAppEventParams(params)

  analytics
    .track(withPrefix(`Book demo button clicked`), eventParams)
    .catch((e: unknown) => {
      logger.error(e)
    })
}

export const useTrackBookDemoButtonClick = (params: Prettify<AppTrackingData>) => clientOnly(() => {
  trackBookDemoButtonClick(params)
})
